import { IconComponentProps } from '../IconTypes';

const Split = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M7.5 11.75C9.84721 11.75 11.75 9.84721 11.75 7.5C11.75 5.15279 9.84721 3.25 7.5 3.25C5.15279 3.25 3.25 5.15279 3.25 7.5C3.25 9.84721 5.15279 11.75 7.5 11.75ZM7.5 13C10.5376 13 13 10.5376 13 7.5C13 4.46243 10.5376 2 7.5 2C4.46243 2 2 4.46243 2 7.5C2 10.5376 4.46243 13 7.5 13Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.5 20.75C18.8472 20.75 20.75 18.8472 20.75 16.5C20.75 14.1528 18.8472 12.25 16.5 12.25C14.1528 12.25 12.25 14.1528 12.25 16.5C12.25 18.8472 14.1528 20.75 16.5 20.75ZM16.5 22C19.5376 22 22 19.5376 22 16.5C22 13.4624 19.5376 11 16.5 11C13.4624 11 11 13.4624 11 16.5C11 19.5376 13.4624 22 16.5 22Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export default Split;
